import { useState } from 'react'

import { ReactComponent as Code } from '../../../../assets/icons/code.svg'
import Popup from '../../../Popup/Popup'
import { IFaqResponsesItem } from '../../faqModels'

import FaqResponseYamlEditor from './FaqResponseYamlEditor/FaqResponseYamlEditor'

import styles from './faq-response-yaml.module.scss'

interface IResponseYamlProps {
    message: IFaqResponsesItem
    selectedFaqItem: string
    getDataFromApi: () => void
}

function FaqResponseYaml(props: IResponseYamlProps) {
    const { message, selectedFaqItem, getDataFromApi } = props

    const [isOpen, setIsOpen] = useState(false)

    return (
        <>
            <button
                className={styles.faqYaml__btn}
                onClick={() => setIsOpen(true)}
            >
                <Code className={styles.faqYaml__icon} />
            </button>
            <Popup
                isOpen={isOpen}
                closePopup={() => setIsOpen(false)}
                className={styles.faqYaml__popup}
            >
                <div>
                    <FaqResponseYamlEditor
                        message={message}
                        getDataFromApi={getDataFromApi}
                        selectedFaqItem={selectedFaqItem}
                        closePopup={() => setIsOpen(false)}
                    />
                </div>
            </Popup>
        </>
    )
}

export default FaqResponseYaml
